export default __webpack_public_path__ + "static/media/forex_image.9fce6e19.png";